// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area {
    width: 100%;
    border-radius: 15px;
    background: var(--field-background);
    padding: 21px 39px;
    border: none;
    box-shadow: none;
    outline: none;
    color: var(--light-black);
    font-family: var(--Inter-SemiBold600);
    font-size: 16px;
    line-height: 26px
}

.text-area:focus {
    outline: 1px solid var(--purple)
}`, "",{"version":3,"sources":["webpack://./src/components/modals/addCoachFeedBack/AddCoachFeedBackModal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,qCAAqC;IACrC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".text-area {\n    width: 100%;\n    border-radius: 15px;\n    background: var(--field-background);\n    padding: 21px 39px;\n    border: none;\n    box-shadow: none;\n    outline: none;\n    color: var(--light-black);\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px;\n    line-height: 26px\n}\n\n.text-area:focus {\n    outline: 1px solid var(--purple)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
